import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import PageTitle from "../../layouts/PageTitle";
import SpinnerLoading from "../../components/spinner-loading/SpinnerLoading";
import FormField from "../../components/ui/FormField";
import CheckboxField from "../../components/ui/CheckboxField";
import SubmitButton from "../../components/ui/SubmitButton";
import { getSingleAdminFunc } from "../../../store/custom-actions/admins-actions/GetSingleAdminSlicer";
import { updateAdminFunc } from "../../../store/custom-actions/admins-actions/UpdateAdminSlicer";

export default function UpdateAdminMainData() {
  const { t } = useTranslation();
  const { adminId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors }, setValue } = useForm();

  const { loading: getSingleAdminLoading, data: singleAdminData } = useSelector(
    (state) => state.getSingleAdminSlicer
  );
  const { loading: updateAdminLoading } = useSelector(
    (state) => state.updateAdminSlicer
  );

  useEffect(() => {
    if (adminId) {
      dispatch(getSingleAdminFunc(adminId));
    }
  }, [adminId, dispatch]);

  useEffect(() => {
    if (singleAdminData) {
      setValue("name", singleAdminData.name);
      setValue("email", singleAdminData.email);
      setValue("phone", singleAdminData.phone);
      setValue("email_verified_at", !!singleAdminData.email_verified_at);
    }
  }, [singleAdminData, setValue]);

  const onSubmit = async (data) => {
    const payload = {
      name: data.name,
      phone: data.phone,
      email: data.email,
      email_verified_at: data.email_verified_at || false,
    };

    const result = await dispatch(
      updateAdminFunc({ id: adminId, data: payload })
    );

    if (updateAdminFunc.fulfilled.match(result)) {
      navigate("/admins");
    }
  };


  return (
    <>
      <PageTitle
        motherMenu={"Admins"}
        activeMenu={"Update Admin"}
        motherMenuPath="/admins"
      />
      {getSingleAdminLoading ? (
        <SpinnerLoading />
      ) : (
        <div className="row">
          <div className="col-xl-12 col-xxl-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">
                  {t("Update")} {t("Admin")}
                </h5>
              </div>
              <div className="card-body">
                <form
                  id="update-admin-form"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <FormField
                        label={t("Name")}
                        name="name"
                        register={register}
                        required={true}
                        errors={errors}
                      />
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <FormField
                        label={t("Email")}
                        name="email"
                        type="email"
                        register={register}
                        required={true}
                        errors={errors}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <FormField
                        label={t("Phone")}
                        name="phone"
                        register={register}
                        required={true}
                        errors={errors}
                      />
                    </div>
                  </div>
                  <CheckboxField
                    name="email_verified_at"
                    label="Email Verified"
                    register={register}
                    errors={errors}
                  />
                  <div className="text-end">
                    <SubmitButton
                      form="update-admin-form"
                      isLoading={updateAdminLoading}
                      label="Submit"
                      loadingLabel={t("Loading")}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}